import { Tooltip } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as TickIcon } from '@assets/icons/tick.svg';

import FabricCategory from '@components/commonFilters/materials/Fabrics/FabricCategory';
import FabricComposition from '@components/commonFilters/materials/Fabrics/FabricComposition';
import FabricSpec from '@components/commonFilters/materials/Fabrics/FabricSpec';
import FabricSubCategory from '@components/commonFilters/materials/Fabrics/FabricSubCategory';
import Gsm from '@components/commonFilters/materials/Fabrics/Gsm';
import MaterialName from '@components/commonFilters/materials/Fabrics/MaterialName';
import { toastError } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { getAllSuppliersMaterials, getCommonFilters } from '@store/reducers';
import { fetchAllSuppliersMaterials } from '@store/supplier/action';
import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

import { getShortName } from '@utils/Util';

import { MATERIALS_TYPE } from '@/constants/constant';

const Fabrics = ({ moodboardId, selectedFabrics = [] }) => {
	const [page] = useState(0);
	const [isHide, setIsHide] = useState(false);
	const [isClearAll, setIsClearAll] = useState(false);
	const materialsData = useSelector(getAllSuppliersMaterials);
	const [isFiter, setIsFilter] = useState(false);
	const refMaterialSearchName = useRef('');

	const commonfilters = useSelector(getCommonFilters);

	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(fetchAllSuppliersMaterials(page, 8, MATERIALS_TYPE.FABRIC, 'id,desc', {}));
	}, [dispatch]);

	const onHide = () => setIsHide(!isHide);
	const onResetClearValue = () => setIsClearAll(false);

	const onApplyClick = () => {
		dispatch(fetchAllSuppliersMaterials(page, 8, MATERIALS_TYPE.FABRIC, 'id,desc', { ...commonfilters }));
		setIsFilter(true);
		onHide();
	};
	const clearSearch = () => {
		refMaterialSearchName.current.value = '';
		setIsFilter(false);
		setIsClearAll(true);
		dispatch(fetchAllSuppliersMaterials(page, 8, MATERIALS_TYPE.FABRIC, 'id,desc', {}));
	};

	const onAddMaterial = async (materialId) => {
		dispatch(openLoader());
		let params = `${moodboardId}/add-material?materialId=${materialId}`;
		await ApiClient.POST('moodboardAction', {}, params)
			.then(({ data }) => {
				dispatch(closeLoader());
				if (data) {
					const { ...rest } = data.payload;
					const fabricData = rest;
					dispatch({
						type: Types.ADD_FABRIC_TO_MOODBOARD,
						payload: fabricData
					});
				}
			})
			.catch(({ response }) => {
				dispatch(closeLoader());
				if (response && response.data && response.data.message) {
					toastError(response.data.message);
				} else {
					toastError('Request was unsuccessful.');
				}
			});
	};

	return (
		<div className="moodboard-fabric-container">
			{/* Suggested Fabrics */}
			<div className="fabric-filter">
				<p className="semibold-14 mb-0">Suggested fabrics</p>
				{/* <span>
					<FilterIcon />
				</span> */}
			</div>
			<div className="mt-2 mb-2">
				<MaterialName
					onHide={onHide}
					type={MATERIALS_TYPE.FABRIC}
					refMaterialSearchName={refMaterialSearchName}
				/>
			</div>
			{isFiter && (
				<div className="filter-items">
					<div className="title mb-2 pb-1 d-flex align-items-center justify-content-between">
						<p className="regular-12 gray_dark_02">{materialsData.data?.length} items</p>
						<button className="button no-padding" onClick={() => clearSearch()}>
							Clear
						</button>
					</div>
				</div>
			)}

			<div className={!isHide ? 'd-none' : ''}>
				<h3 className="semibold-14">Filter</h3>
				<div className="filter-items-container">
					<FabricCategory isClearAll={isClearAll} onResetClearValue={onResetClearValue} />
					<FabricSubCategory isClearAll={isClearAll} onResetClearValue={onResetClearValue} />
					<FabricComposition isClearAll={isClearAll} onResetClearValue={onResetClearValue} />
					<Gsm isClearAll={isClearAll} onResetClearValue={onResetClearValue} />
					<FabricSpec isClearAll={isClearAll} onResetClearValue={onResetClearValue} />
					<div className="apply-buttons text-right">
						<button className="button outline size32" onClick={onHide}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={() => onApplyClick()}>
							Apply
						</button>
					</div>
				</div>
			</div>

			<div className="fabric-all-items">
				{materialsData.data?.length > 0 ? (
					materialsData?.data?.map((item) => (
						<div className="fabric-single-item" key={item?.materialId}>
							<div className="fabric-image">
								{/* {item?.docUrl && (
									<img src={item?.docUrl} alt="item" className="material-image" />
								)} */}
								{item?.docUrl ? (
									<img src={item?.docUrl} alt="item" className="material-image" />
								) : (
									<img
										src={`${process.env.PUBLIC_URL}/icons/fabric-defauld.svg`}
										alt=""
										className="material-image"
									/>
								)}
								{selectedFabrics.includes(item?.materialId) ? (
									<span className="selected-tick">
										<TickIcon />{' '}
									</span>
								) : (
									<span
										className="select"
										onClick={(e) => {
											e.stopPropagation();
											onAddMaterial(item.materialId);
										}}
									>
										<TickIcon />
									</span>
								)}
							</div>

							<Tooltip
								title={<h5 className="font-12">{item?.name}</h5>}
								placement="top"
								arrow
								className="cursor-pointer"
							>
								<p>{getShortName(item?.name, 40)}</p>
							</Tooltip>
						</div>
					))
				) : (
					<p className="no-material">No material found</p>
				)}
			</div>
		</div>
	);
};

export default Fabrics;
